import fp from 'lodash/fp';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { vsprintf } from 'sprintf-js';
import { auth0ErrorCodes, routes } from '../../constants';
import { Icon } from '../components';

/**
 * Responsible to parse and render error messages that returned from Auth0 API calls.
 * @see https://auth0.com/docs/api/authentication?javascript#standard-error-responses
 */
class Auth0Error extends Component {

  renderAuth0Error() {
    if (this.props.user.error && this.props.user.error.code === auth0ErrorCodes.userExists) {
      return (
        <div>
          <span className='alert alert-secondary' style={{ fontSize: '14px' }}>
            You already have an account with us, please <Link to={{ pathname: routes.login, search: this.props.location && this.props.location.search }}>log in</Link> to continue.
          </span>
        </div>
      );
    }

    if (this.props.user.error && typeof (this.props.user.error.description) === 'string') {
      return (
        <div>
          <span className='alert alert-secondary' style={{ fontSize: '14px' }}>
            {this.props.user.error.description}
          </span>
        </div>
      );
    }

    if (this.props.user.error && typeof (this.props.user.error.description) === 'object') {
      if (this.props.user.error.description.rules) {
        let { rules } = this.props.user.error.description;
        return (
          <div className='alert alert-secondary' style={{ fontSize: '14px' }}>
            <span><Icon iconSet='glyphicon' icon='warning-sign' />{'Your password is too weak. It must meet the following rules:'}</span>
            <ul style={{ display: 'table', textAlign: 'left' }}>
              {
                fp.map(function (rule) {
                  if (rule.items) {
                    return (
                      <li key={rule.code}>
                        {vsprintf(rule.message, rule.format)}
                        <ul>
                          {
                            fp.map(function (item) {
                              return (
                                <li key={item.message}>
                                  {item.message}
                                </li>
                              );
                            })(rule.items)
                          }
                        </ul>
                      </li>
                    );
                  }
                  else {
                    return (
                      <li key={rule.code}>
                        {vsprintf(rule.message, rule.format)}
                      </li>
                    );
                  }
                })(rules)
              }
            </ul>
          </div>
        );
      }
    }

    return this.props.user.error ? <div style={{ color: 'red', padding: '5px' }}>{'Sorry, we have encountered an issue with your account, please contact Caddie support.'}</div> : '';
  }

  render() {
    return (
      <div>
        {
          this.renderAuth0Error()
        }
      </div>
    );
  }
}

export default Auth0Error;



// WEBPACK FOOTER //
// ./src/containers/components/auth0-error.js